import React, { useState } from 'react';
import {
  VStack,
  FormControl,
  Input,
  Button,
  FormLabel,
  InputGroup,
  InputRightElement,
  HStack,
} from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

const PasswordInputSection = () => {
  const [show, setShow] = useState(false);
  return (
    <VStack spacing={2} mb={2} align="stretch">
      <FormControl>
        <FormLabel fontWeight="medium" color="gray.700" mb={1}>
          Password
        </FormLabel>
        <InputGroup>
          <Input
            type={show ? 'text' : 'password'}
            placeholder="Enter Your Password"
            size="lg"
          />
          <InputRightElement h="full">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setShow((s) => !s)}
              tabIndex={-1}
            >
              {show ? <ViewOffIcon /> : <ViewIcon />}
            </Button>
          </InputRightElement>
        </InputGroup>
      </FormControl>
      <HStack justify="flex-end" mb={1}>
        <Button variant="link" colorScheme="blue" fontSize="sm" p={0} h="auto">
          Forgot Password?
        </Button>
      </HStack>
      <Button colorScheme="blue" size="lg" w="full">
        Sign in
      </Button>
    </VStack>
  );
};

export default PasswordInputSection; 